/* One delegated control also covers Theme Editor section replacements. */
(function () {
  'use strict';
  if (window.AquonMarquee) return;
  window.AquonMarquee = true;
  function boot(scope) {
    (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-aqmb-toggle]').forEach(function (button) { button.hidden = false; });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-aqmb-toggle]');
    if (!button) return;
    var bar = button.closest('.aqmb');
    if (!bar) return;
    var paused = bar.classList.toggle('is-paused');
    button.setAttribute('aria-label', paused ? 'Play announcement' : 'Pause announcement');
    button.querySelector('[data-aqmb-pause]').toggleAttribute('hidden', paused);
    button.querySelector('[data-aqmb-play]').toggleAttribute('hidden', !paused);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
